import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export const AddCourseMasterSlice = createSlice({
  name: "AddCourseMasterSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    addCourseMaster: (state, action) => {
      state.isLoading = true;
    },
    successaddCourseMaster: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureaddCourseMaster: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    resetaddCourseMaster: (state) => {
      state.data = undefined;
      state.isLoading = false;
    },
  },
});

export const {
  addCourseMaster,
  failureaddCourseMaster,
  resetaddCourseMaster,
  successaddCourseMaster,
} = AddCourseMasterSlice.actions;

export default AddCourseMasterSlice.reducer;
